import { Box, Button, Link, Typography } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router';

const UnregisteredBanner = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: 'flex', backgroundColor: 'primary.main', p: 3, alignItems: 'center' }}>
      <Box
        display='flex'
        flexDirection='column'
        sx={{ width: '66%' }}
      >
        <Typography
          fontWeight='bold'
          sx={{ fontSize: 32 }}
          variant='caption'
        >
          See the data in GX Go
        </Typography>
        <Typography
          sx={{ fontSize: 20 }}
          variant='caption'
        >
          Sign up for GX Go to explore thousands of oil and energy transition spot prices and
          forward curves - or find out more on the General Index{' '}
          <Link
            href='https://www.general-index.com'
            rel='noopener noreferrer'
            sx={{
              color: 'text.primary',
              textDecorationColor: 'rgb(248 248 248 / 40%)',
              '--Link-underlineColor': 'rgb(248 248 248 / 40%)'
            }}
            target='_blank'
          >
            website
          </Link>
          .
        </Typography>
      </Box>
      <Box
        display='flex'
        justifyContent='center'
        width='34%'
      >
        <Box
          alignItems='center'
          display='flex'
          flexDirection='column'
        >
          <Button
            sx={{ backgroundColor: 'text.primary', width: 208 }}
            variant='contained'
            onClick={() => {
              navigate('/onboarding');
            }}
          >
            <Typography
              color='primary.main'
              fontWeight='bold'
              variant='body1'
            >
              TRY FOR FREE
            </Typography>
          </Button>
          <Typography
            marginTop={0.5}
            variant='body2'
          >
            Already have an account?{' '}
            <Link
              component={RouterLink}
              sx={{
                color: 'text.primary',
                textDecorationColor: 'rgb(248 248 248 / 40%)',
                '--Link-underlineColor': 'rgb(248 248 248 / 40%)',
                fontWeight: 700
              }}
              to='../login'
            >
              Login
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default UnregisteredBanner;
